(ns common.resource.adset
  {:deprecated true}
  (:require [common.db.interceptors :refer [forwarded-event]]
            [common.url-template :as url-tpl]
            [mate.re-frame :as mr]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]))

(def instance-url (:api/adset url-tpl/templates))

(rf/reg-event-fx :layer.adset/get-content-function
  [forwarded-event]
  (fn [{:keys [db]} [_ version]]
    (-> {:db db}
        (mr/update-db dissoc :resource.content-function/one)
        (mr/conj-fx [:dispatch [:resource.content-function/get-one {:params {:stage version}}]]))))

(rf/reg-event-fx :layer.adset/destroy
  (fn [{:keys [db]} _]
    {:db (dissoc db
                 :resource.adset/one
                 :resource.feed-importers/one
                 :resource.feed-importers/content-feed
                 :resource.content-variants/all)}))

(rf/reg-event-db :resource.adset/get-one-success
  [(rf/path :resource.adset/one)]
  (fn [_ [_ adset]]
    {:state :success :value (assoc adset :templateRevisionIds (mapv :id (:templateRevisions adset)))}))

(rf/reg-event-fx :resource.adset/get-one-failure
  (fn [{:keys [db]} _]
    {:db (assoc-in db [:resource.adset/one :state] :failure)
     :fx [[:dispatch [:router/update-controller-status
                      {:failure? true
                       :failure-props {:code "not_found_error"
                                       :entity-name "Adset"}}]]]}))

(rf/reg-event-fx :resource.adset/post-preview-token
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx}]
    {:db (assoc db :resource.adset/preview-token {:state :pending
                                                  :value nil})
     :http
     {:method :post
      :uri (url-tpl/render :api/adset-preview-token url-context)
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success [:resource.adset/post-preview-token-success]
      :on-failure [:resource.adset/post-preview-token-failure]}}))

(rf/reg-event-db :resource.adset/post-preview-token-success
  (fn [db [_ {:keys [token]}]]
    (assoc db :resource.adset/preview-token {:state :success
                                             :value token})))

(rf/reg-event-db :resource.adset/post-preview-token-failure
  (fn [db _]
    (assoc db :resource.adset/preview-token {:state :failure})))

(rf/reg-event-fx :resource.adset/patch
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ params {:keys [on-success on-failure]
                                                 :or {on-success [:resource.adset/patch-success]
                                                      on-failure [:resource.adset/patch-failure]}}]]
    {:http
     {:method :patch
      :uri (url-tpl/render instance-url url-context)
      :params params
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success on-success
      :on-failure on-failure}}))

(rf/reg-event-fx :resource.adset/patch-success
  (fn [{:keys [db]} [_ adset]]
    {:db (update-in db [:resource.adset/one :value] merge adset)
     :fx [[:invalidate-queries {:queryKey ["adsets" (:campaignId adset)]}]
          [:invalidate-queries {:queryKey ["adset" (:id adset)]}]]}))

(rf/reg-event-db :resource.adset/patch-failure
  identity)

(rf/reg-sub :resource.adset/one
  (fn [db]
    (:resource.adset/one db)))

(rf/reg-sub :resource.adset/state
  :<- [:resource.adset/one]
  (fn [{:keys [state]} _]
    state))

(rf/reg-sub :resource.adset/current-feed-id
  :<- [:resource.adset/one]
  (fn [adset]
    (get-in adset [:value :feedId])))

(rf/reg-sub :resource.adset/has-feed?
  :<- [:resource.adset/current-feed-id]
  (fn [current-feed-id]
    (some? current-feed-id)))

(rf/reg-sub :resource.adset/template-ids
  :<- [:resource.adset/one]
  (fn [adset _]
    (get-in adset [:value :templateRevisionIds])))

(rf/reg-sub :resource.adset/has-templates?
  :<- [:resource.adset/template-ids]
  (fn [template-ids _]
    (-> template-ids seq boolean)))

(rf/reg-sub :resource.adset/current-channel
  :<- [:resource.adset/one]
  (fn [adset]
    (get-in adset [:value :channel])))

(rf/reg-sub :resource.adset/current-workflow
  :<- [:resource.adset/one]
  (fn [adset _]
    (get-in adset [:value :workflow])))

(rf/reg-sub :resource.adset/current-target-type
  :<- [:resource.adset/one]
  (fn [adset _]
    (keyword (or (:targetType (:value adset)) :generic))))

(rf/reg-sub :resource.adset/preview-token
  (fn [db]
    (:resource.adset/preview-token db)))

(rf/reg-sub :resource.adset/rules-preview-url
  :<- [:url-context]
  :<- [:resource.adset/preview-token]
  :<- [:resource.content-function-version/version-names]
  :<- [:resource.content-function-version/active-version {:only-staged true}]
  (fn [[url-context {token :value} version-names active-stage-version]]
    (when (seq version-names)
      (r.easy/href :adset/rules-preview
                   (merge url-context {:preview-token token})
                   {:stage (:name active-stage-version)}))))
